export const dicionario = {
  especie: 'Espécie',
  espacamento: 'Espaçamento',
  especificacao: 'Especificação',
  raca: 'Raça',
  numeroAnimais: 'Número de animais',
  tipoCriacao: 'Tipo de criação',
  outrasCriacoes: 'Outras criações',
  dataInicio: 'Data de início',
  previsaoColheita: 'Previsão colheita',
  areaDestinada: 'Área destinada',
  especificacaoOutros: 'Especificação Outros',
  outrasEspecies: 'Outras Espécies'
}



// WEBPACK FOOTER //
// ./src/libs/utils/forms/dicionario.js